import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Layout from "../inc/layout-frontend";  
import PdfViewer from "../PdfViewer";

export default function Consultation(props){

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const pdfUrl = "http://127.0.0.1:3002/document.pdf"; // searchParams.get("pdfUrl");
    const documentTitle = searchParams.get("documentTitle");
    const viewerRef = useRef(null)
    
    const iframe = document.createElement('iframe');
    //const test = `/pdfjs-3.10.111-dist/web/viewer.html?file=${pdfUrl}`;
    iframe.src = `/pdfjs-3.10.111-dist/web/viewer.html?file=${pdfUrl}`;
    iframe.width = '100%';
    iframe.height = '100%';

    console.log(iframe)

    return(
        <Layout> 
            {/* Mise en page pour la page de consultation */}
            <div className="container-fluid position-relative p-0">
                <div className="container-fluid bg-primary py-5 bg-header" style={{ marginBottom:"90px" }}>
                    <div className="row py-5">
                        <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                            <h1 className="display-4 text-white animated zoomIn">Consultation</h1>
                            <Link className="h5"  style={{ color:"goldenrod"}} to={myroutes.moncompte}>
                                Mon compte
                            </Link>
                            <i className="far fa-circle text-white px-2"></i>
                            <Link className="h5 text-white">
                                Consulation publication
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            {/* Afficher le PDF dans un iframe */}
            <div>
            <div className="px-5" >
                    <h5 className="fw-bold text-primary text-uppercase"></h5>
                  <span>Mon document <Link to={myroutes.moncompte} type="button"  className="btn btn-outline-primary btn-floating" data-mdb-ripple-color="dark"><i className="fas fa-arrow-left-long"></i> </Link></span> 
                   <h1 className="text-legend mb-3 ">{documentTitle}</h1>
                </div>
            {/** */}  
            </div>
            <div style={{padding:"50px"}}> 
            {/** <iframe src={pdfUrl + "#toolbar=0"} width="100%" height="1200px" />   
            <embed src={pdfUrl} type="application/pdf" width="100%" height="1220px" sandbox="allow-scripts" />*/} 
            
            <div ref={viewerRef} id='viewer' style={{ width: '100%', height: '100%' }}>
        
            </div>
            {iframe.onload}
            <iframe 
            src="/pdfjs/web/viewer.html?file=document.pdf" 
            width="100%" 
            height="100%" 
            ></iframe>
            </div>
            {pdfUrl}  

        </Layout>
    )
}
